(function () {
	'use strict';

	angular
		.module('app')
		.controller('FilesController', FilesController)

	FilesController.$inject = ['FotosService', "$http", "$timeout", "$uibModal", "$log", "$document", "$sce"];

	function FilesController(FotosService, $http, $timeout, $uibModal, $log, $document, $sce) {
		var vm = this;
		vm.value = "";
		vm.maxFiles = "";
		vm.fieldname = "";
		vm.thumbratio = "";
		vm.sizes = [];
		vm.node_id = "";
		vm.folderSeleccionada = 0;
		vm.fotos = [];
		vm.listaFotos = [];
		vm.listadoChecked = [];
		vm.pagina = 0;
		vm.lang_id = "";
		vm.$log = $log;
		vm.modalFotos = "";
		vm.carpetas = [{
			'id': 0,
			'title': 'Todas',
			'contador': 0,
			'nodes': []
		}];

		vm.sortableOptions = {
			placeholder: "app",
			handle: ".moveFotos",
			stop: function (e, ui) {
				//console.log("ok");
				vm.modifyInput();
			},

		};
		vm.initVars = function (parentScope) {
			if (typeof parentScope.control != 'undefined') {
				vm.lang_id = parentScope.control.lang_id;
			} else {
				if (typeof parentScope.appVm != 'undefined') {
					vm.lang_id = parentScope.appVm.lang_id;
				} else {
					vm.lang_id = 1;
				}
			}
			////console.log(parentScope);
		}
		vm.init = function () {
			if (vm.value != "" && vm.value != 0) {
				FotosService.getListaFotos(vm.value, vm.sizes, function (data) {
					$timeout(function () {
						vm.fotos = data.fotos;
					})
				});
			}
		}

		function getListaServerFun() {
			////console.log(vm.value);
			FotosService.getServidorFotos(vm, "", function (data) {

				vm.modalFotos = $uibModal.open({
					animation: true,
					ariaLabelledBy: 'modal-title-top',
					ariaDescribedBy: 'modal-body-top',
					templateUrl: 'listaFotos.html',
					size: 'fullscreen',
					controller: function ($scope) {
						$scope.listaFotos = data.fotos;
						$scope.fieldname = vm.fieldname;
						$scope.vm = angular.copy(vm);
						vm.listaFotos = data.fotos;
						$scope.treeOptions = {
							dragStop: function (event) {
								////console.log(event);
								var carpetaOrigen = event.source.nodeScope.$modelValue;
								var carpetaDestino = event.dest.nodesScope.$nodeScope.$modelValue;
								var indexDestino = event.dest.index;
								FotosService.moverCarpeta(carpetaOrigen, carpetaDestino, indexDestino, function (data) {
								});
							},
							accept: function (sourceNodeScope, destNodesScope, destIndex) {
								//console.log(sourceNodeScope);
								return true;
							}
						};
						$scope.altFoto = function (foto) {
							vm.altFoto(foto);
						}
						vm.carpetas[0].contador = data.numeroFotos;
						vm.carpetas[0].nodes = data.listaFolders;
						$scope.listFolders = vm.carpetas;
						$scope.buscar = "";

						$scope.borrarFotoServidor = function (foto) {
							vm.borrarFotoServidor(foto);
						}

						$scope.newSubItem = function (scope) {
							console.log(scope.$parent.node);
							var nodeData = scope.$parent.node;
							FotosService.nuevaCarpeta(nodeData, function (data) {
								$timeout(function () {
									nodeData.nodes.push({
										id: data.id,
										title: data.title,
										contador: 0,
										nodes: []
									});
								});
							});
						}
						$scope.updateFolder = function (node) {
							FotosService.updateCarpeta(node, function (data) {

							});
						}
						$scope.idsArray = [];
						$scope.buscarDentro = function (node) {
							for (var cont = 0; cont < node.length; cont++) {
								$scope.idsArray.push(node[cont].id);
								$scope.buscarDentro(node[cont].nodes);
							}
						}
						$scope.refrescarLista = function (buscar) {
							$scope.listaFotos = [];
							vm.pagina = 0;
							FotosService.refreshList(buscar, vm, function (data) {
								$timeout(function () {
									for (var cont = 0; cont < data.fotos.length; cont++) {
										$scope.listaFotos.push(data.fotos[cont]);
									}
									vm.listaFotos = $scope.listaFotos;
								});
							});
						}
						$scope.filtrarListaServer = function (scope) {
							console.log("scope", scope);
							var node = scope.$parent.node;
							$scope.idsArray = [node.id];
							$scope.buscarDentro(node.nodes);

							vm.folderSeleccionada = $scope.idsArray;
							vm.pagina = 0;
							$scope.listaFotos = [];
							FotosService.getServidorFotos(vm, $scope.buscar, function (data) {
								$timeout(function () {
									for (var cont = 0; cont < data.fotos.length; cont++) {
										$scope.listaFotos.push(data.fotos[cont]);
									}
								});
							});
						}
						vm.listadoChecked = [];
						if (vm.value != "") {
							var splitVal = vm.value.split(",");
							for (var cont = 0; cont < splitVal.length; cont++) {
								vm.listadoChecked.push(splitVal[cont]);
							}
						}

						$scope.addFotoChecked = function (foto) {
							var resultado = false;
							for (var cont = 0; cont < vm.listadoChecked.length && !resultado; cont++) {
								if (vm.listadoChecked[cont] == foto.file_id) {
									resultado = true;
									vm.listadoChecked.splice(cont, 1);
								}
							}
							////console.log(resultado);
							if (!resultado) {
								if (foto.file_id > 0) {
									vm.listadoChecked.push(foto.file_id);
								}
							}

						}
						$scope.callListaFoto = function () {
							vm.pagina++;
							FotosService.getServidorFotos(vm, $scope.buscar, function (data) {
								$timeout(function () {
									for (var cont = 0; cont < data.fotos.length; cont++) {
										$scope.listaFotos.push(data.fotos[cont]);
									}
								});
							});
						}
						$scope.okForm = function () {
							//console.log(vm.listadoChecked.join(","));
							if (vm.listadoChecked.length > 0) {
								if (vm.listadoChecked.length > vm.maxFiles && vm.maxFiles > 0) {
									for (var cont = vm.maxFiles; cont < vm.listadoChecked.length; cont++) {
										vm.listadoChecked.splice(cont, 1);
										cont--;
									}
									alert("Este campo está limitado a " + vm.maxFiles);
								}

								FotosService.getListaFotos(vm.listadoChecked.join(","), vm.sizes, function (data) {
									$timeout(function () {
										//console.log(vm.listadoChecked);
										vm.value = vm.listadoChecked.join(",");
										//console.log('#'+vm.fieldname+'-idphoto');
										vm.fotos = data.fotos;
										$('#' + vm.fieldname + '-idphoto').val(vm.listadoChecked.join(",")).trigger("change");
										vm.modalFotos.close();
										vm.modalFotos = "";
									})
								});
							} else {
								if (vm.fieldname != "") {
									$timeout(function () {
										vm.value = "";
										//console.log('#'+vm.fieldname+'-idphoto');
										vm.fotos = [];
										$('#' + vm.fieldname + '-idphoto').val("").trigger("change");
										vm.modalFotos.close();
										vm.modalFotos = "";
									});
								} else {
									$timeout(function () {
										vm.modalFotos.close();
										vm.modalFotos = "";
									});
								}
							}
						}
						$scope.koForm = function () {
							//vm.value = vm.listadoChecked.join(",");
							vm.modalFotos.close();
							vm.modalFotos = "";
						}
					}
				});
			})
		}
		vm.modalInfo = "";
		vm.altFoto = function (foto) {
			FotosService.getInfoFoto(foto, vm, function (data) {
				vm.modalInfo = $uibModal.open({
					animation: true,
					ariaLabelledBy: 'modal-title-top',
					ariaDescribedBy: 'modal-body-top',
					templateUrl: 'fotoAlt.html',
					size: 'md',
					controller: function ($scope) {
						$timeout(function () {
							$scope.fotoInfo = data.info;
							$scope.carpetas = data.carpetas;
							$scope.fotoInfo.carpeta = $scope.fotoInfo.carpeta.toString();
						})


						$scope.okForm = function () {
							FotosService.saveInfo($scope.fotoInfo, vm, function (data) {
								////console.log(vm);
								$timeout(function () {
									vm.carpetas[0].nodes = data.carpetas;
								})
								vm.modalInfo.close();
							})
						}

						$scope.koForm = function () {
							vm.modalInfo.close();
						}
					}
				});
			});
		}

		vm.getListaServer = function () {
			vm.pagina = 0;
			getListaServerFun();
		}

		vm.modalCrop = {};
		vm.cropCords = {};
		vm.cropFoto = function (foto) {
			vm.modalCrop[foto.id] = $uibModal.open({
				animation: true,
				ariaLabelledBy: 'modal-title-top',
				ariaDescribedBy: 'modal-body-top',
				templateUrl: 'cropFoto.html',
				size: 'lg',
				controller: function ($scope) {
					$scope.sizes = [];
					for (var cont = 0; cont < vm.sizes.length; cont++) {
						$scope.sizes.push(JSON.parse(vm.sizes[cont]));
					}
					$scope.foto = foto;
					$scope.foto.width = $scope.sizes[0].width;
					$scope.foto.height = $scope.sizes[0].height;
					$scope.foto.file_path = $scope.foto.file_path.replace("thumbs/", "");
					$scope.foto.crop = vm.sizes;
					$scope.changeCrop = function (size) {
						$scope.foto.width = size.width;
						$scope.foto.height = size.height;
						//$scope.foto.file_path = 'imgen/2-170130.jpg';
					}
					$scope.okForm = function () {
						FotosService.cropearFoto($scope.foto, vm.cropCords, function (data) {
							for (var cont = 0; cont < $scope.foto.crops.length; cont++) {
								$scope.foto.crops[cont].path = $scope.foto.crops[cont].path + "?1";
							}
							//vm.modalCrop.close();
						});
					}
					$scope.showCoords = function (c) {
						vm.cropCords = c;
					}
					$scope.koForm = function () {
						vm.modalCrop[foto.id].close();
					}
				}
			});
		}




		vm.modifyInput = function () {
			var ids = [];
			for (var cont = 0; cont < vm.fotos.length; cont++) {
				ids.push(vm.fotos[cont].file_id);
			}
			////console.log(ids.join(","));
			vm.value = ids.join(",");
			$timeout(function () {
				$('#' + vm.fieldname + '-idphoto').val(ids.join(",")).trigger("change");
			})
		}

		vm.pushFotos = function (fotos) {
			var resultado = false;
			////console.log(fotos);
			vm.listadoChecked = [];
			//console.log(vm.fotos.length);
			for (var cont = 0; cont < vm.fotos.length; cont++) {
				vm.listadoChecked.push(vm.fotos[cont].file_id);
			}
			for (var cont = 0; cont < fotos.length && !resultado; cont++) {
				if (vm.maxFiles > vm.fotos.length || vm.maxFiles == 0) {
					vm.fotos.push(fotos[cont]);
					vm.listadoChecked.push(fotos[cont].file_id);
				} else {
					resultado = true;
				}
			}
			//console.log(vm.listadoChecked);
			if (resultado) {
				alert("Este campo está limitado a " + vm.maxFiles);
			}
			vm.modifyInput();
		}

		vm.borrarFoto = function (foto) {
			var resultado = false;
			for (var cont = 0; cont < vm.fotos.length && !resultado; cont++) {
				if (vm.fotos[cont] == foto) {
					vm.fotos.splice(cont, 1);
					resultado = true;
				}
			}
			vm.modifyInput();
		}


		vm.modalBorrarServer = "";
		vm.borrarFotoServidor = function (foto) {
			vm.modalBorrarServer = $uibModal.open({
				animation: true,
				ariaLabelledBy: 'modal-title-top',
				ariaDescribedBy: 'modal-body-top',
				templateUrl: 'borrarFoto.html',
				size: 'md',
				controller: function ($scope) {
					$scope.foto = foto;
					$scope.okForm = function () {
						FotosService.borrarFotoServer(foto, function (data) {
							var resultado = false;
							////console.log(vm.fotos.length);
							for (var cont = 0; cont < vm.listaFotos.length && !resultado; cont++) {
								if (vm.listaFotos[cont].file_id == foto.file_id) {
									resultado = true;
									vm.listaFotos.splice(cont, 1);
								}
							}
							vm.modalBorrarServer.close();
						})

					}

					$scope.koForm = function () {
						vm.modalBorrarServer.close();
					}
				}
			});
			/*FotosService.getListaFotos(foto,function(data){
				$timeout(function(){
					//borramos la foto del listado aqui
				})
			});*/
		}

	}

})();